export const FETCH_POWER_FACTOR_TREND_REQUEST =
  '[PowerFactorTrend] FETCH_POWER_FACTOR_TREND_REQUEST';
export const FETCH_POWER_FACTOR_TREND_SUCCESS =
  '[PowerFactorTrend] FETCH_POWER_FACTOR_TREND_SUCCESS';
export const FETCH_POWER_FACTOR_TREND_FAILURE =
  '[PowerFactorTrend] FETCH_POWER_FACTOR_TREND_FAILURE';
